import { ProductFormProductIngredient } from "src/pages/Product/ProductForm/ProductForm.types";

export const getProductIngredientTransportKey = (ingredient: ProductFormProductIngredient): string | null => {
    if (ingredient.ingredient !== undefined) {
        const referenceSource = ingredient.ingredient.referenceSource;
        const referenceId = ingredient.ingredient.ingredientReferenceId;
        if (referenceSource !== undefined && referenceId !== undefined) {
            return `ingredient-reference:${referenceSource}:${referenceId}`;
        }

        return `ingredient:${ingredient.ingredient["@id"]}`;
    }

    if (ingredient.intermediateProduct !== undefined) {
        return `intermediate-product:${ingredient.intermediateProduct["@id"]}`;
    }

    if (ingredient.ingredientReference !== undefined) {
        return `ingredient-reference:${ingredient.ingredientReference.source}:${ingredient.ingredientReference.id}`;
    }

    return null;
};
